import React from 'react';

import { EHeadingWeight } from '@domain/enums/components/EHeading';
import { useProductDetails } from '@helpers/hooks/pages/dashboard/productAnalytics/useProductDetails';
import { numberFormatter } from '@helpers/masks';
import PieChart from './PieChart';

import * as S from './styles';

const CreditCard: React.FC = () => {
  const { productFinancialDetailsReport } = useProductDetails();

  const { boleto } = productFinancialDetailsReport;

  return (
    <S.Card>
      <S.Content>
        <S.Title fontWeight={EHeadingWeight.LIGHT}>Boleto</S.Title>

        <S.DataWrapper>
          <S.ChartWrapper>
            <PieChart />
            <S.ChartPercentage>{`${numberFormatter(
              boleto.conversion,
              0,
              true,
            )}%`}</S.ChartPercentage>
          </S.ChartWrapper>

          <S.OrdersDataWrapper>
            <S.OrdersStatusWrapper>
              <S.OrdersAmountAndQuantity>
                <S.OrdersAmount>{`R$ ${numberFormatter(boleto.paid.amount, 2)}`}</S.OrdersAmount>
                <S.OrdersQuantity>{`(${boleto.paid.quantity})`}</S.OrdersQuantity>
              </S.OrdersAmountAndQuantity>

              <S.StatusWrapper>
                <S.ApprovedBullet />
                <S.StatusText>Aprovados</S.StatusText>
              </S.StatusWrapper>
            </S.OrdersStatusWrapper>

            <S.OrdersStatusWrapper>
              <S.OrdersAmountAndQuantity>
                <S.OrdersAmount>{`R$ ${numberFormatter(boleto.pending.amount, 2)}`}</S.OrdersAmount>
                <S.OrdersQuantity>{`(${boleto.pending.quantity})`}</S.OrdersQuantity>
              </S.OrdersAmountAndQuantity>

              <S.StatusWrapper>
                <S.InAnalysisBullet />
                <S.StatusText>Pendentes</S.StatusText>
              </S.StatusWrapper>
            </S.OrdersStatusWrapper>

            <S.OrdersStatusWrapper>
              <S.OrdersAmountAndQuantity>
                <S.OrdersAmount>{`R$ ${numberFormatter(
                  boleto.compensated.amount,
                  2,
                )}`}</S.OrdersAmount>
                <S.OrdersQuantity>{`(${boleto.compensated.quantity})`}</S.OrdersQuantity>
              </S.OrdersAmountAndQuantity>

              <S.StatusWrapper>
                <S.CompensatedBullet />
                <S.StatusText>Compensados</S.StatusText>
              </S.StatusWrapper>
            </S.OrdersStatusWrapper>
          </S.OrdersDataWrapper>
        </S.DataWrapper>
      </S.Content>
    </S.Card>
  );
};

export default CreditCard;
